import { useTranslation } from "@sagot/i18n";
import { Button, Dialog, DialogContent, Icon } from "@sagot/ui";

const K = "build.agentKnowledge.piiConfirm";

interface PiiConfirmDialogProps {
  name: string;
  /** Kinds of personal data found in the source (e.g. "email addresses"). */
  kinds: readonly string[];
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Shown before a source with personal data in it is opened to Everyone (guests included). */
export function PiiConfirmDialog({ name, kinds, pending, onConfirm, onCancel }: PiiConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onCancel(); }}>
      <DialogContent
        className="max-w-md"
        title={t(`${K}.title`, { name })}
        closeLabel={t("common.close")}
        footer={
          <>
            <Button type="button" variant="ghost" onClick={onCancel}>
              {t(`${K}.cancel`)}
            </Button>
            <Button type="button" variant="danger" loading={pending} onClick={onConfirm}>
              {t(`${K}.confirm`)}
            </Button>
          </>
        }
      >
        <div className="flex items-start gap-3">
          <span className="inline-flex size-10 shrink-0 items-center justify-center rounded-pill bg-accent-soft text-accent-ink">
            <Icon name="alert-triangle" className="size-5" />
          </span>
          <p className="text-sm text-fg-muted">{t(`${K}.body`, { kinds: kinds.join(", ") })}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
